import * as React from "react";
import { Controlled as CodeMirror } from "react-codemirror2";

// load CodeMirror themes, language support, and addons on client-side only
if (typeof window === "object") {
	require("codemirror/lib/codemirror.css");
	require("codemirror/addon/lint/lint.css");
	require("codemirror/mode/javascript/javascript");
	require("codemirror/addon/lint/lint");
	require("codemirror/addon/lint/json-lint");
	require("../styles/codemirror.css");
	const jsonlint = require("jsonlint");
	(window as any).jsonlint = jsonlint.parser;
}

/**
 * react wrapper for codemirror editor
 * can be read-write or read-only
 */

interface EditorProps {
	value: string;
	onChangeValue?: (value: string) => void;
	isReadOnly?: boolean;
	style?: React.CSSProperties;
	language?: string;
}

const MODE_FOR_LANGUAGE = {
	["json"]: "application/json",
	["javascript"]: "application/javascript",
};

class EditorComponent extends React.Component<EditorProps, any> {
	render() {
		const options: any = {
			lineNumbers: true,
			mode: MODE_FOR_LANGUAGE[this.props.language],
			gutters: ["CodeMirror-lint-markers"],
			theme: "lucario",
			lint: true,
			lineWrapping: true,
		};

		if (this.props.isReadOnly === true) {
			options.readOnly = true;
		}

		return (
			<div
				style={{
					position: "relative",
					width: "100%",
					height: "100%",
					...(this.props.style || {}),
				}}
			>
				<CodeMirror
					className="codemirror-editor"
					value={this.props.value}
					onBeforeChange={(editor, data, value) => {
						if (this.props.onChangeValue !== undefined) {
							this.props.onChangeValue(value);
						}
					}}
					onChange={(v, data, value) => {
						if (this.props.onChangeValue !== undefined) {
							this.props.onChangeValue(value);
						}
					}}
					options={options}
				/>
			</div>
		);
	}
}

export default EditorComponent;



// WEBPACK FOOTER //
// ./src/components/Editor.tsx